import { t } from "i18next";

import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";

export const anthropometricApi = api
  .enhanceEndpoints({ addTagTypes: ["anthropometric"] })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      anthropometric: builder.query({
        query: ({ id }: any) => ({
          url: `/users/${id}/assessment/anthropometric`,
          method: RequestMethod.GET,
        }),
        transformResponse: (response: any) => response,
      }),
      postAnthropometric: builder.mutation({
        query: ({ id, anthropometricData }) => ({
          url: `/users/${id}/anthropometric`,
          method: RequestMethod.POST,
          body: anthropometricData,
        }),
      }),

      anthropometricChart: builder.query({
        query: ({ id }: any) => ({
          url: `/users/${id}/assessment/chart`,
          method: RequestMethod.GET,
        }),
        transformResponse: (response: any) => response,
      }),

      //notes // user/assessment/anthropometric/note/288
      getNotes: builder.query({
        query: ({ id }: any) => ({
          url: `/user/assessment/anthropometric/note/${id}`,
          method: RequestMethod.GET,
        }),
        transformResponse: (response: any) => response,
      }),
      postNotes: builder.mutation({
        query: ({ id, notesData }) => ({
          url: `/user/assessment/anthropometric/note/${id}`,
          method: RequestMethod.POST,
          body: notesData,
        }),
      }),
    }),
  });

export const {
  useAnthropometricQuery,
  usePostAnthropometricMutation,
  useAnthropometricChartQuery,
  useGetNotesQuery,
  usePostNotesMutation,
} = anthropometricApi;
